/**
 * ISO 4217 Currency Codes
 * Comprehensive list of world currencies with their codes and names
 */

export interface Currency {
  code: string;
  name: string;
  symbol?: string;
}

export const CURRENCIES: Currency[] = [
  // EUR first (default)
  { code: 'EUR', name: 'Euro', symbol: '\u20ac' },
  // CZK second
  { code: 'CZK', name: 'Czech Koruna', symbol: 'K\u010d' },
  // Rest alphabetically
  { code: 'AED', name: 'UAE Dirham' },
  { code: 'AUD', name: 'Australian Dollar', symbol: '$' },
  { code: 'BGN', name: 'Bulgarian Lev' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: '$' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'Fr' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '\u00a5' },
  { code: 'DKK', name: 'Danish Krone', symbol: 'kr' },
  { code: 'GBP', name: 'British Pound Sterling', symbol: '\u00a3' },
  { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft' },
  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp' },
  { code: 'ILS', name: 'Israeli New Shekel', symbol: '\u20aa' },
  { code: 'INR', name: 'Indian Rupee', symbol: '\u20b9' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '\u00a5' },
  { code: 'KRW', name: 'South Korean Won', symbol: '\u20a9' },
  { code: 'MXN', name: 'Mexican Peso', symbol: '$' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: '$' },
  { code: 'PLN', name: 'Polish Zloty', symbol: 'z\u0142' },
  { code: 'RON', name: 'Romanian Leu', symbol: 'lei' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: '$' },
  { code: 'THB', name: 'Thai Baht', symbol: '\u0e3f' },
  { code: 'TRY', name: 'Turkish Lira', symbol: '\u20ba' },
  { code: 'TWD', name: 'New Taiwan Dollar', symbol: '$' },
  { code: 'UAH', name: 'Ukrainian Hryvnia', symbol: '\u20b4' },
  { code: 'USD', name: 'United States Dollar', symbol: '$' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
];

export const DEFAULT_CURRENCY = 'EUR';

/**
 * Format currency display with code and name
 */
export function formatCurrencyDisplay(currency: Currency): string {
  return `${currency.code} - ${currency.name}`;
}

/**
 * Get currency by code
 */
export function getCurrencyByCode(code: string): Currency | undefined {
  return CURRENCIES.find(c => c.code === code);
}
